// extracted by mini-css-extract-plugin
export default {"tab_menu":"TabMenu_tab_menu__02Bdu","on":"TabMenu_on__rkPj6","align_left":"TabMenu_align_left__seECw","border_st":"TabMenu_border_st__DGje2"};